import { ApolloLink } from 'apollo-link';
import {
  getMainDefinition,
  hasDirectives,
  removeArgumentsFromDocument,
  removeDirectivesFromDocument,
} from 'apollo-utilities';
import { DocumentNode, VariableNode } from 'graphql';

const GATEWAY_DIRECTIVE = 'gateway';
const GATEWAY_ENABLED_ARG = 'gatewayEnabled';

export const stripGatewayDirective = new ApolloLink((operation, forward) => {
  if (!hasDirectives([GATEWAY_DIRECTIVE], operation.query)) {
    return forward(operation);
  }

  // Remove @gateway directive
  let strippedQuery = removeDirectivesFromDocument([{ name: GATEWAY_DIRECTIVE }], operation.query);
  if (strippedQuery) {
    operation.query = strippedQuery;
  }

  // Remove gatewayEnabled variable declaraction
  strippedQuery = removeArgumentsFromDocument([{ name: GATEWAY_ENABLED_ARG }], operation.query);
  if (strippedQuery) {
    operation.query = strippedQuery;
  }

  // Remove gatewayEnabled variable value since the backend will error otherwise
  let variableValue: any = undefined;
  if (operation.variables) {
    variableValue = operation.variables[GATEWAY_ENABLED_ARG];
    delete operation.variables[GATEWAY_ENABLED_ARG];
  }
  return forward(operation).map(data => {
    // Restore variable
    operation.variables[GATEWAY_ENABLED_ARG] = variableValue;
    return data;
  });
});

export const isGatewayRequest = (query: DocumentNode, variables: Record<string, any>) => {
  const definition = getMainDefinition(query);
  const foundDirective = definition.directives?.find(
    directive => directive.name.value === GATEWAY_DIRECTIVE
  );

  // If no @gateway then false
  if (!foundDirective) {
    return false;
  }

  // Identify if directive looks like this: @gateway(enabled: $gatewayEnabled)
  const enabledArg = foundDirective.arguments?.find(n => n.name.value === 'enabled');
  if (!enabledArg) {
    // no param found, so this always goes to Gateway
    return true;
  }

  // Check if operation is enabled based on LD flag
  const variableName = (enabledArg.value as VariableNode).name.value;
  return variables[variableName] === true;
};
